$.fn.SLR_ContactDocumentEditor = function(contact_data)
{
	var _editor = this;
	_editor.action = "telecharger";
	_editor.contact_data = contact_data;
	_editor.print_iframe = undefined;
	_editor.document_mailer = undefined;

	// set action for next
	_editor.setAction = function(action)
	{
		_editor.action = action;
		switch (_editor.action) {
			case "download":
				_editor.attr("target", "_self");
				_editor.attr("action", "/contact/telecharger/fiche/" + _editor.contact_data.id);
				_editor.find("span.action-label").text("Télécharger la fiche complète");
				_editor.find(".btn .material-symbols-outlined").text("download");
				break;
			case "print":
				if (_editor.print_iframe != undefined){
					_editor.print_iframe.remove();
				}
				_editor.print_iframe = $('<iframe></iframe>').attr("name", "print_iframe").css({
					width : '1px',
					height : '1px',
					position : 'fixed',
					top : '-1px',
					left : '-1px'
				});
				$("body").append(_editor.print_iframe);
				_editor.find("span.action-label").text("Imprimer la fiche complète");
				_editor.find(".btn .material-symbols-outlined").text("print");
				break;
			case "email":
				_editor.attr("target", "_self");
				_editor.attr("action", "/contact/enregistrer/fiche/" + _editor.contact_data.id);
				_editor.find("span.action-label").text("Préparer pour l'envoi");
				_editor.find(".btn .material-symbols-outlined").text("send");
				break;
		}
	};

	// post data
	_editor.post_data = function()
	{
		switch (_editor.action) {
			case "download":
				_editor.submit();
				_editor.modal('hide');
				break;
			case "print":
				var print_icon = _editor.find("i");
				print_icon.removeClass("fa-print").addClass("fa-circle-o-notch fa-spin");
				var src = "/assets/libraries/pdfjs/web/viewer.html?file=",
					file = "/contact/previsualiser/fiche/" + _editor.contact_data.id;
				file += "?editor_title=" + _editor.find("input[name=editor_title]").val();
				file += "&editor_production=" + _editor.find("input[name=editor_production]").val();
				file += "&editor_role=" + _editor.find("input[name=editor_role]").val();
				file += "&editor_dates=" + _editor.find("input[name=editor_dates]").val();
				var note = _editor.find("textarea[name=editor_note]").val();
				note = note.replace(/(?:\r\n|\r|\n)/g, '||BR||');
				file += "&editor_note=" + note;
				src += encodeURIComponent(file);
				_editor.print_iframe.attr("src", src);
				window.endPrintProcess = function(){
					var print_icon = _editor.find("i");
					print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-print");
					_editor.modal('hide');
				};
				break;
			case "email":
				var email_icon = _editor.find("i");
				email_icon.removeClass("fa-envelope-o").addClass("fa-circle-o-notch fa-spin");
				_editor.ajaxSubmit({
					success: function(){
						var print_icon = _editor.find("i");
						print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-envelope-o");
						_editor.modal('hide');
						_editor.document_mailer.modal('show');
					}
				});
				break;
		}
		return false;
	};

	return function()
	{
		_editor.find(".btn-action-generate").on("click", _editor.post_data);
		_editor.document_mailer = $("#email-contact-modal").clone().EmailComposer(_editor.contact_data);
		_editor.find("h5.modal-title").text(_editor.contact_data.full_name);
		_editor.find("input[name=editor_contact_id]").val(_editor.contact_data.id);
		return _editor;
	}();
};

$.fn.SLR_ContactActions = function()
{
	var self = this;
	if (self.data("init") == true) return;
	self.data("init", true);
	self.contact_data = self.data("contact");
	self.document_editor = undefined;
	self.document_mailer = undefined;

	// Submit action to API
	self.submit_action = function(action, permission_key, permission_value)
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "contact");
		request.append("id", self.contact_data.id);
		request.append("action", action);
		if (permission_key != undefined && permission_value != undefined){
			data[permission_key] = permission_value;
		}
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	// Delete contact
	self.delete_contact = function()
	{
		swal({
			title: "Suppression d'une fiche technique",
			text: "Êtes-vous sûr de vouloir supprimer cette fiche technique et le compte utilisateur associé? Cette action est protégée par mot de passe.",
			type: "input",
			customClass: "delete-contact-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Supprimer',
			closeOnConfirm: false,
			inputPlaceholder: "Mot de passe"
		}, function (inputValue){
			$.post("/login/permission", {
				privilege: 'CONTACT_DELETE',
				password: inputValue
			}, function(x){
				if (x.success){
					// got permission, delete using key
					swal({
						title: "Suppression en cours...",
						text: "La fiche technique est en cours de suppression.",
						type: "success",
						showConfirmButton: false,
						timer: 2000
					});
					self.submit_action("delete", x.action, x.key);
				} else {
					// didn't get permission
					swal({
						title: "Erreur",
						text: "Mot de passe incorrect.",
						type: "error",
						confirmButtonClass: "btn-danger"
					});
				}
			}, 'json');
		});
		$(".delete-contact-swal").find(".form-control").attr("type", "password").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
		return false;
	};

	// Download contact
	self.download_contact = function()
	{
		if (self.document_editor == undefined){
			self.document_editor = $("#contact-document-editor-modal").clone().SLR_ContactDocumentEditor(self.contact_data);
		}
		self.document_editor.setAction("download");
		self.document_editor.modal('show');
		return false;
	};

	// Print contact
	self.print_contact = function()
	{
		if (self.document_editor == undefined){
			self.document_editor = $("#contact-document-editor-modal").clone().SLR_ContactDocumentEditor(self.contact_data);
		}
		self.document_editor.setAction("print");
		self.document_editor.modal('show');
		return false;
	};

	// Email contact
	self.email_contact = function()
	{
		if (self.document_editor == undefined){
			self.document_editor = $("#contact-document-editor-modal").clone().SLR_ContactDocumentEditor(self.contact_data);
		}
		self.document_editor.setAction("email");
		self.document_editor.modal('show');
		return false;
	};

	// Print coordinates
	self.print_document = function()
	{
		$('.print-frame').remove();
		var print_icon = $(this).find("i");
		print_icon.removeClass("fa-print").addClass("fa-circle-o-notch fa-spin");
		var print_iframe = $('<iframe></iframe>').attr("src", "/assets/libraries/pdfjs/web/viewer.html?file=" + encodeURIComponent($(this).attr("href"))).css({
			width : '1px',
			height : '1px',
			position : 'fixed',
			top : '-1px',
			left : '-1px'
		}).addClass("print-frame");
		$("body").append(print_iframe);
		window.endPrintProcess = function(){
			print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-print");
		};
		return false;
	};

	// Email coordinates
	self.email_coords = function()
	{
		self.coordinates_mailer = $('#email-coords-modal').clone().EmailComposer(self.contact_data);
		$(self.coordinates_mailer).modal('show');
		return false;
	};

	return function()
	{
		// initialize actions
		self.find(".btn-action-delete-contact").on("click", self.delete_contact);
		self.find(".btn-action-download-contact").on("click", self.download_contact);
		self.find(".btn-action-print-contact").on("click", self.print_contact);
		self.find(".btn-action-email-contact").on("click", self.email_contact);
		self.find(".btn-action-print-coords").on("click", self.print_document);
		self.find(".btn-action-email-coords").on("click", self.email_coords);
		self.find(".btn-action-print-labels").on("click", self.print_document);
		return self;
	}();
};
